(function ($) {
    "use strict";

    function setTextInsideCookieNotationContainer($content) {
        // вставляем данный текст в тэг для текста у кук, ниже выполнена данная реализация

        var origin = window.location.origin;
        var host = window.location.host;
        var privacyPolicyStaticFilePath = "/static/cookies/";

        var isFcWebsite = $('body').hasClass('fc');

        if (isFcWebsite) {
            // Условия обработки метрических данных в системе Россия - футбольная страна.pdf
            privacyPolicyStaticFilePath += "fc-privacy-policy.pdf";
        } else {
            // Условия обработки метрических данных в системе Официальный Сайт РФС.pdf
            privacyPolicyStaticFilePath += "rfs-privacy-policy.pdf";
        }

        var websiteLocationHtmlLink = "<a href=\"" + origin + "\">" + host + "</a>";
        var privacyPolicyHtmlLink = "<a href=\"" + privacyPolicyStaticFilePath +
            "\" target=\"_blank\">Условиями обработки метрических данных</a>";

        var resultText = "Мы&nbsp;обрабатываем Cookies для улучшения работы сайта, анализа трафика, персонализации сервисов и&nbsp;удобства пользователей. " +
            "Используя сайт или кликая на&nbsp;«Я&nbsp;согласен», Вы&nbsp;соглашаетесь с&nbsp;Условиями обработки метрических данных на&nbsp;" +
            websiteLocationHtmlLink + ". " +
            "Вы&nbsp;можете запретить обработку Cookies в&nbsp;настройках браузера. Пожалуйста, ознакомьтесь с&nbsp;" +
            privacyPolicyHtmlLink +
            " в&nbsp;системе " +
            websiteLocationHtmlLink + ". "
        ;

        $content.html(resultText);
    }

    function setCrossSubdomainCookie(name, value, days) {
        var assign = name + "=" + escape(value) + ";";
        var d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString() + ";";
        var path = "path=/;";
        var domain = "domain=" + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + ";";
        document.cookie = assign + expires + path + domain;
    }

    function getCookie(name) {
        var prefix = name + "=",
            cookieStartIndex = document.cookie.indexOf(prefix),
            cookieEndIndex;
        if(cookieStartIndex === -1) {
            return null;
        }
        cookieEndIndex = document.cookie.indexOf(";", cookieStartIndex + prefix.length);
        if(cookieEndIndex === -1) {
            cookieEndIndex = document.cookie.length;
        }
        return decodeURI(document.cookie.substring(cookieStartIndex + prefix.length, cookieEndIndex));
    }

    function addInBodyCustomEvent() {
        var yaEvent = new Event("ya-metrica");
        var body = document.querySelector("body");
        body.dispatchEvent(yaEvent);
    }

    $(document).on("ready", function () {
        $(".js-cookie-notation-text").each(function () {
            setTextInsideCookieNotationContainer($(this));
        });

        $(".js-cookie-notation").each(function () {
            var DEFAULT_COOKIE_NAME = "cookie_notation";
            var $t = $(this);
            var cookieItemName = $t.data("cookie-name");
            var cookieName = cookieItemName ? cookieItemName : DEFAULT_COOKIE_NAME;

            if(getCookie(cookieName) === null) {
                $t.show();

                $t.on("click", ".js-confirm-cookie", function () {
                    $t.hide();
                    setCrossSubdomainCookie(cookieName, 1, 365);
                    addInBodyCustomEvent();
                });
            } else {
                addInBodyCustomEvent();
            }
        });
    });

})(jQuery);
